module.exports = __webpack_public_path__ + "media/images/evidence-rie-9775b290.svg";